import { createFeature } from '@ngrx/store';

import { tagsReducer } from './tags.reducer';

export const tagsFeatureKey = 'tags';

export const tagsFeature = createFeature({
  name: tagsFeatureKey,
  reducer: tagsReducer,
});
